import { Center, Spinner, Text } from '@chakra-ui/react'

interface TabletCenterSpinnerProps {
    title?: string
}

export const TabletCenterSpinner = ({ title = 'Создаём запись' }: TabletCenterSpinnerProps) => {
    return (
        <Center flexDirection='column' gap='6' h='full' px='6' w='full'>
            <TabletSpinner />
            <Text
                color='text.fg'
                fontSize='heading'
                fontWeight='semibold'
                lineHeight='120%'
                textAlign='center'
            >
                {title}
            </Text>
            <Text
                color='text.fg_muted'
                fontSize='2xl'
                fontWeight='regular'
                lineHeight='120%'
                textAlign='center'
            >
                Пожайлуста, подождите
            </Text>
        </Center>
    )
}

export const TabletSpinner = () => <Spinner borderWidth='6px' color='mistySage.500' h='16' w='16' />
